import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

async function parseResponseError(response, fallbackMessage) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || fallbackMessage);
}

export const fetchOperatorSensorAccess = async () => {
    const response = await apiFetch(`${API_BASE}/sensors/operator/access`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося визначити доступ до сенсорів");
    }
    return await response.json();
};

export const listOperatorSensors = async () => {
    const response = await apiFetch(`${API_BASE}/sensors/operator/devices`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося завантажити сенсори");
    }
    return await response.json();
};

export const assignOperatorSensor = async (payload) => {
    const response = await apiFetch(`${API_BASE}/sensors/operator/devices/assign`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося призначити сенсор");
    }
    return await response.json();
};

export const updateOperatorSensor = async (sensorId, payload) => {
    const response = await apiFetch(`${API_BASE}/sensors/operator/devices/${encodeURIComponent(sensorId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося оновити сенсор");
    }
    return await response.json();
};

export const fetchOperatorSensorEvents = async (sensorId, options = {}) => {
    const { limit = 100, dateFrom = "", dateTo = "" } = options;
    const params = new URLSearchParams();
    params.set("limit", String(limit));
    if (dateFrom) params.set("date_from", dateFrom);
    if (dateTo) params.set("date_to", dateTo);

    const response = await apiFetch(
        `${API_BASE}/sensors/operator/devices/${encodeURIComponent(sensorId)}/events?${params.toString()}`
    );
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося завантажити історію сенсора");
    }
    return await response.json();
};

export const fetchOperatorSensorProvisioning = async (sensorId) => {
    const response = await apiFetch(`${API_BASE}/sensors/operator/devices/${encodeURIComponent(sensorId)}/provisioning`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося отримати дані для налаштування сенсора");
    }
    return await response.json();
};